<div mat-dialog-content>
    <div class="modal-login">
        <form #form="ngForm">
            <div class="table-sio w-100">
                <div class="row-sio">
                    <div class="cell-sio">
                        <input type="email" name="Usr" id="txUsr" class="w-100"
                            placeholder="Ingresa aquí tu correo electrónico" [(ngModel)]="login.usr" autocomplete="off"
                            (keyup.enter)="onLogin()" required />
                    </div>
                </div>
                <div class="row-sio">
                    <div class="cell-sio">
                        <input type="password" name="Pass" id="txPass" class="w-100" placeholder="Contraseña"
                            [(ngModel)]="login.pass" autocomplete="off" (keyup.enter)="onLogin()" />
                        <label [ngClass]="validaCorreo() ? 'unlink' : 'link'" (click)="recuperarContrasena()">Obtener mi
                            Contraseña</label>
                    </div>
                </div>
                <div class="row-sio">
                    <div class="cell-sio text-center">
                        <button mat-flat-button [color]="styleCocheSeguro?.colorBtn" (click)="onLogin()"
                            [disabled]="!form.valid">ENTRAR</button>
                    </div>
                </div>
            </div>
        </form>
    </div>
</div>